<template>
  <div id="adminPage" class="page white" ref="adminPage">
    <el-container class="content-aside">
      <!-- Left Side -->
       <!-- Note: The mt-8 class adds a top margin of 32px which is being referenced in updatePageComponentStyle of utils.js-->
      <el-main class="bg-white cpl-main mt-8">
        <!-- The options class is necessary here to include AdminHeader in the calculation of main content height (updatePageComponentStyle in utils.js). This can be removed once we refactor the tag-slider -->
        <AdminHeader
          class="options"
          v-model="searchKey"
          @invite-user-click="inviteUserClicked(true)"
        />

        <div
          v-if="showTagsSlider"
          class="relative mx-4 h-[6px]"
        >
          <tag-slider
            :accessorComponentProp="'adminPage'"
            :refreshTagSliderProp="refreshTagSlider"
            @tag-slider-change="handleTagSliderChange($event)">
          </tag-slider>
        </div>

        <!-- Content -->
        <el-row id="listOfUsersWrapper" :gutter="0" class="main-content-row grey-background">
          <div class="users-list-content hide-scrollbar pt-4">
            <div class="users">
              <template v-for="(userItem, index) in filteredUserList">
                <draggable
                  v-if="userItem._edit.showUserRow"
                  v-bind="sortDraggableOptions"
                  :key="`${index}-container`"
                  :id="`${userItem.userId}-container`"
                  :list="[userItem]"
                  :group="{ name: 'tags-shared', pull: false, put: true }"
                  tag="div"
                  item-key="userId"
                  ghost-class="sortable-ghost"
                  @change="handleTagDraggableChange($event, userItem)"
                >
                  <template #item="{ element: user, index: indx }">
                    <div
                      :id="user.userId"
                      :class="['user-row', { 'drop-disabled': !user._edit?.enableAddUserTags, 'selected': user._edit.isUserRowSelected}]">

                      <div class="user-row-color" :style="user._edit.rowBackgroundStyle"></div>

                      <div @click.capture="handleUserRowClickCapture($event, user, indx)"
                        :class="{'row-content': true,
                        'mouse-over': (user._edit.mouseEvent && user._edit.mouseEvent === 'mouseover'),
                        'mouse-out': (user._edit.mouseEvent && user._edit.mouseEvent === 'mouseout')}"
                        @mouseover="handleUserRowItemMouseHoverAndMouseOut('mouseover', user)"
                        @mouseout="handleUserRowItemMouseHoverAndMouseOut('mouseout', user)"
                        class="row-content">

                        <div class="picture">
                          <div :class="{pic: true, 'user-white': user.picture === null}">
                            <img v-if="user.picture !== null" :src="user.picture">
                          </div>
                        </div>

                        <div class="user-info">
                          <div class="name">{{`${user.firstName} ${user.lastName}`}}</div>
                          <div class="email">{{`${user.email}`}}</div>
                        </div>

                        <div class="row-actions">
                          <!-- User Rights action -->
                          <div :class="[{'user-rights-default': (!user.tags || !user.tags.length), 'user-rights-with-user-tags': (user.tags && user.tags.length) }]">
                            <div class="user-rights_actions flex! flex-row-reverse justify-start">
                              <template v-for="(right, indx) in allowableRightsOptions">
                                <template v-if="showUserRightOption(right, user)">
                                  <el-tooltip
                                    :v-if="false"
                                    :key="indx"
                                    :popper-class="'custom-tooltip-popper'"
                                    :show-arrow="false"
                                    effect="light"
                                    :content="tooltip[indx]"
                                    placement="bottom"
                                    class="item">

                                    <div
                                      :class="[
                                        'icons',
                                        {
                                          'grayscale': (user.rights.indexOf(right) < 0),
                                          'disabled-action': (user._edit.disableUserRights.indexOf(right) >= 0),
                                          'disabled-remove-own-admin': (user._edit.disabledRemoveOwnUserAdmin && right === allowableRightsOptions[USER_RIGHTS.ARYA_ADMIN]),
                                          'hide-action': (user._edit.disableUserRights.includes(right) && !user._edit.isLoggedInUser) || (user._edit.isLoggedInUser && right !== allowableRightsOptions[USER_RIGHTS.ARYA_ADMIN])
                                        }
                                      ]"
                                      @click="handleUserRightsIconClick(right, user)">

                                      <div :class="`user_right_action_icon ${right}`"></div>
                                    </div>
                                  </el-tooltip>
                                </template>
                              </template>

                              <template v-if="user._edit.isUserGlobalAdmin">
                                <el-popover
                                  popper-class="custom-popover-popper !p-4 !text-xs"
                                  placement="bottom"
                                  width="255"
                                  trigger="hover">
                                  <template #reference>
                                    <div class="icons !cursor-not-allowed">
                                      <div class="user_right_action_icon account_admin"></div>
                                    </div>
                                  </template>
                                  <template #default>
                                    <div class="flex flex-col gap-4 text-xs">
                                      <b >{{ $t('texts.hubGlobalAdmin') }}</b>
                                      <p>{{ $t('texts.hubGlobalAdminDesc') }}</p>
                                    </div>
                                  </template>
                                </el-popover>
                              </template>
                            </div>

                            <!-- User Tags -->
                            <div v-if="user.tags && user.tags.length"
                              :class="['user-tags-wrapper',
                              {'no-user-limited': !showUserRightOption(allowableRightsOptions[USER_RIGHTS.ARYA_LIMITED], user),
                              'no-user-create-and-schedule': (user.rights.indexOf(allowableRightsOptions[USER_RIGHTS.ARYA_LIMITED]) >= 0) && (user.rights.indexOf(allowableRightsOptions[USER_RIGHTS.ARYA_CREATE]) < 0 && user.rights.indexOf(allowableRightsOptions[USER_RIGHTS.ARYA_SCHEDULE]) < 0)}]">
                              <div class="user-tags-flex">
                                  <template v-for="(userTag, indx) in user.tags" :key="indx">
                                    <div :class="['user-tag']" :id="`adminUserTag-${userTag.id}`">
                                      <div class="user-tag-background" :style="{backgroundColor: userTag.backgroundColor }"></div>
                                      <div :class="['user-tag-name']">{{userTag.value}}</div>
                                      <div @click="handleUserTagDeleteClick(user, userTag)" class="remove-user-tag"></div>
                                    </div>

                                    <!--To Show more tags-->
                                    <div :class="['user-tag show-all-tags']" :id="`adminUserTag-${userTag.id}-show-all-tags`">
                                      <div class="user-tag-background show-all-tags" :style="{backgroundColor: '#A8A8A8' }"></div>
                                      <div :class="['user-tag-name show-all-tags']">{{'●●●'}}</div>
                                    </div>
                                  </template>
                              </div>
                            </div>
                          </div>

                          <div class="delete_action">
                            <div @click="handleDelete(user)" :class="['user_right_action_icon delete_icon', {'disabled': user._edit.disabledDeleteUser}]"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </draggable>
              </template>
            </div>
          </div>
        </el-row>
      </el-main>

      <!-- Right Side -->
      <el-aside class="cpl-aside">
        <admin-user-invite
          v-if="!userSelection.length"
          :showUserFormProp="showUserForm"
          @admin-menu-change="handleAdminUserInviteChanged"
          @close-invite-user-form="inviteUserClicked(false)"
        />
        <div v-else class="right-side-menu last-login">
          <div class="last-login-content">
            <div class="title">{{$t('label.lastLogin')}}</div>
            <div class="last-login-val">{{userSelection[0]._edit.lastLogin}}</div>
          </div>
        </div>
      </el-aside>
    </el-container>
  </div>
</template>

<script src="./admin.js"></script>
<style lang="scss" src="./admin.scss"></style>
